<template>
  <div class="app-email-w forse-show-content">
    <div class="app-email-i">
      <div class="ae-side-menu">
        <ul class="ae-main-menu">
          <li>
            <select
              class="form-control"
              autofocus="autofocus"
              v-model="current.tienda"
              @change="refreshBodega"
            >
              <option
                v-for="(tienda, key) in tiendas"
                :value="tienda.codigo"
                :key="key"
                >{{ tienda.nombre }}</option
              >
            </select>
          </li>
          <li v-for="bodega in bodegas" :key="bodega.id">
            <a href="#">
              <span>{{ bodega.descripcion }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="ae-list-w">
        <div
          class="ae-list ps ps--theme_default ps--active-y"
          style="height: auto;"
        >
          <div class="ae-item with-status status-green">
            <div class="aei-image">
              <div class="user-avatar-w">
                <img alt="" src="img/avatar1.jpg" />
              </div>
            </div>
            <div class="aei-content">
              <div class="aei-timestamp">
                1:25pm
              </div>
              <h6 class="aei-title">
                James Morgan
              </h6>
              <div class="aei-sub-title">
                Create new profile request
              </div>
              <div class="aei-text">
                When the equation, first to ability the forwards, the a but
                travelling
              </div>
            </div>
          </div>
          <div class="ae-item with-status status-green">
            <div class="aei-image">
              <div class="user-avatar-w">
                <img alt="" src="img/avatar2.jpg" />
              </div>
            </div>
            <div class="aei-content">
              <div class="aei-timestamp">
                11:12am
              </div>
              <h6 class="aei-title">
                Kyle Jefferson
              </h6>
              <div class="aei-sub-title">
                Document Verification
              </div>
              <div class="aei-text">
                When the equation, first to ability the forwards, the a but
                travelling
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ae-content-w">
        <div class="">
          <div class="older-pack">
            <div class="aec-full-message-w">
              <div class="aec-full-message">
                <div class="message-head">
                  <div class="user-w with-status status-green">
                    <div class="user-avatar-w">
                      <div class="user-avatar">
                        <img alt="" src="img/avatar1.jpg" />
                      </div>
                    </div>
                    <div class="user-name">
                      <h6 class="user-title">
                        Bryan Kinskey
                      </h6>
                      <div class="user-role">
                        Registration Question<span
                          >&lt; bryan@solutions.com &gt;</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="message-info">February 7th, 2017<br />2:27pm</div>
                </div>
                <div class="message-content">
                  Greetings Bryan,<br /><br />Classes of there been temple. Rung
                  quite head the may devious usual. A century thing if but
                  support turn start he a subject if what live was become write
                  that suspicion case fundamentals office his her. Earnestly a
                  the and on a phase samples examples, tone.<br /><br />Regards,<br />Mike
                  Mayers
                </div>
              </div>
            </div>
          </div>
          <div class="aec-full-message-w">
            <div class="aec-full-message">
              <div class="message-head">
                <div class="user-w with-status status-green">
                  <div class="user-avatar-w">
                    <div class="user-avatar">
                      <img alt="" src="img/avatar1.jpg" />
                    </div>
                  </div>
                  <div class="user-name">
                    <h6 class="user-title">
                      John Mayers
                    </h6>
                    <div class="user-role">
                      Account Manager<span>&lt; john@solutions.com &gt;</span>
                    </div>
                  </div>
                </div>
                <div class="message-info">January 12th, 2017<br />1:24pm</div>
              </div>
              <div class="message-content">
                Hi Mike,
                <br />
                <br />
                midst of next.
                <br /><br />Regards,<br />Mike Mayers
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TiendaSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
      tiendas: [],
      bodegas: [],
      current: {
        tienda: '02',
      },
    };
  },
  mounted() {
    this.refreshBodega();
    this.refreshTiendas();
  },
  methods: {
    refreshTiendas() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((res) => {
        self.tiendas = res.data;
      });
    },
    refreshBodega() {
      let self = this;
      DynamicService.fetch("cat", "tienda-bodega", {
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.bodegas = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cat-productos-editar",
        params: { sku: current.sku },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cat", "productos", params).then((res) => {
        self.data = res.data;
      });
    },
    showModalEdit() {},
  },
};
</script>
